import React from "react";
import { Avatar, Chip, Typography } from "@mui/material";
import paymentCategoryLogoDictionary from "../../paymentCategoryLogoDictionary";
import { sortDateTime } from "../../utils/utils";

export const PspConfigUISchema = (updateToggleDialog) => {
  const schema = {
    metadata: {
      title: "Payment Gateway Configurations",
      minHeight: 600,
      minWidth: 500,
      position: "relative",
      rowHeight: 120,
      showTitle: false,
      defaultSortInfo: { name: "addedDTime", dir: -1 },
    },
    fields: [
      {
        name: "legalEntityName",
        header: "Business Units",
        visible: true,
        type: "string",
        filtering: false,
        defaultFlex: 1,
        minWidth: 170,
        textAlign: "start",
        sortable: true,
        render: ({ data }) => {
          return (
            <span style={{ display: "flex", marginLeft: "-12px" }}>
              {data?.legalEntityName}
            </span>
          );
        },
      },

      {
        name: "pspName",
        header: "PSP Name",
        visible: true,
        type: "string",
        filtering: false,
        defaultFlex: 1,
        minWidth: 150,
        textAlign: "start",
        sortable: true,
        render: ({ data }) => {
          return (
            <span style={{ display: "flex", marginLeft: "-12px" }}>
              {data?.pspName}
            </span>
          );
        },
      },
      {
        name: "countryCode",
        header: "Country",
        visible: true,
        type: "string",
        filtering: false,
        defaultFlex: 1,
        minWidth: 150,
        textAlign: "start",
        sortable: true,
        render: ({ data }) => {
          return (
            <span style={{ display: "flex", marginLeft: "-12px" }}>
              {data?.countryCode}
            </span>
          );
        },
      },
      {
        name: "currencyCodes",
        header: "Currencies",
        visible: true,
        type: "string",
        filtering: false,
        defaultFlex: 1,
        minWidth: 200,
        textAlign: "start",
        sortable: false,
        render: ({ data }) => {
          return (
            <span style={{ display: "flex", marginLeft: "-12px" }}>
              {data?.currencyCodes}
            </span>
          );
        },
      },
      {
        name: "paymentCategories",
        header: "Payment Categories",
        visible: true,
        type: "string",
        filtering: false,
        defaultFlex: 4,
        minWidth: 360,
        textAlign: "start",
        sortable: false,
        render: ({ data }) => {
          return (
            <span style={{ marginLeft: "-12px" }}>
              {data?.paymentCategories.map((category) => (
                <Chip
                  key={category?.name}
                  sx={{
                    marginBottom: 1,
                    marginRight: 1,
                    fontFamily: "Poppins",
                  }}
                  avatar={
                    <Avatar
                      style={{ height: "16px", width: "16px" }}
                      src={paymentCategoryLogoDictionary[category?.type]?.logo}
                      alt="Category Image"
                    />
                  }
                  label={category?.name}
                  variant="outlined"
                />
              ))}
            </span>
          );
        },
      },
      {
        name: "addedDTime",
        header: "added Time",
        visible: false,
        type: "datetime",
        filtering: false,
        defaultFlex: 1,
        minWidth: 250,
        textAlign: "start",
        sort: sortDateTime,
        sortable: true,
        render: ({ data }) => {
          return (
            <span style={{ display: "flex", marginLeft: "-12px" }}>
              {data?.addedDTime}
            </span>
          );
        },
      },
      {
        name: "Action",
        header: "Action",
        visible: true,
        filtering: false,
        defaultFlex: 1,
        minWidth: 186,
        sortable: false,
        textAlign: "start",
        render: ({ data }) => {
          return (
            <div
              style={{
                cursor: "pointer",
              }}
              onClick={() =>
                updateToggleDialog(true, data)
              }
            >
              <img src="/assets/routingIcons/Edit-icon.svg" alt="Edit records" />
            </div>
          );
        },
      },
    ],
  };
  return schema;
};
